module.exports = __webpack_public_path__ + "static/media/3040162000_01.28794973.jpg";